import api from '../../api/nodeBackApi';

export const createCheckoutSession = async (paymentConfig) => {
  const formData = new FormData();

//------------- ALERT!!
// payment amount should be in cents for Stripe

  const paymentInCents = parseInt(paymentConfig.amount) * 100; // Convert to cents

    formData.append('currency', paymentConfig.currency);
    formData.append('amount', paymentInCents);
    formData.append('customerId', paymentConfig.customerId);
    formData.append('camQuantity', paymentConfig.licenseTimeInMonths);
    formData.append('projectId', paymentConfig.paymentDayConfig);

  try {
    // La instancia 'api' maneja automáticamente los headers de autorización y Content-Type
    const response = await api.post('/api/payments/create-checkout-session', formData);
    console.log('Pago configurado exitosamente.');
    return response.data;
  } catch (error) {
    console.error("Error al configurar el pago:", error);
    throw error;
  }
};